import {
  AccountBookOutlined,
  AntDesignOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BlockOutlined,
  BookOutlined,
  BugOutlined,
  BuildOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CloudUploadOutlined,
  ClusterOutlined,
  ControlOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  FireOutlined,
  FolderOutlined,
  FormOutlined,
  GiftOutlined,
  GlobalOutlined,
  HeartOutlined,
  HistoryOutlined,
  HomeOutlined,
  IdcardOutlined,
  KeyOutlined,
  LayoutOutlined,
  LinkOutlined,
  LockOutlined,
  LoginOutlined,
  MailOutlined,
  MenuOutlined,
  MoneyCollectOutlined,
  PieChartOutlined,
  ProfileOutlined,
  RiseOutlined,
  RocketOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  SendOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingOutlined,
  SmileOutlined,
  SoundOutlined,
  StarOutlined,
  SwapOutlined,
  TableOutlined,
  TagsOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  TransactionOutlined,
  TranslationOutlined,
  TrophyOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import type { ComponentType } from 'react';

/**
 * 菜单可用图标表
 * 资源管理里可直接从这些名字中选择，避免全量引入 @ant-design/icons 造成体积膨胀
 */
export const ICON_MAP: Record<string, ComponentType<any>> = {
  HomeOutlined,
  DashboardOutlined,
  AppstoreOutlined,
  BlockOutlined,
  BuildOutlined,
  TableOutlined,
  SettingOutlined,
  ToolOutlined,
  MenuOutlined,
  UserOutlined,
  TeamOutlined,
  IdcardOutlined,
  ProfileOutlined,
  SafetyOutlined,
  SafetyCertificateOutlined,
  LockOutlined,
  LinkOutlined,
  GlobalOutlined,
  ApiOutlined,
  CloudUploadOutlined,
  FileTextOutlined,
  FolderOutlined,
  DatabaseOutlined,
  ClusterOutlined,
  BarChartOutlined,
  PieChartOutlined,
  BellOutlined,
  MailOutlined,
  ShopOutlined,
  GiftOutlined,
  SmileOutlined,
  StarOutlined,
  HeartOutlined,
  FireOutlined,
  ThunderboltOutlined,
  TrophyOutlined,
  ExperimentOutlined,
  RocketOutlined,
  AntDesignOutlined,
  // ── 以下为 Task 7 菜单目录（src/constants/menuCatalog.ts）新增 ──
  AccountBookOutlined,
  ApartmentOutlined,
  AuditOutlined,
  BankOutlined,
  BookOutlined,
  BugOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  ControlOutlined,
  CreditCardOutlined,
  FileProtectOutlined,
  FormOutlined,
  HistoryOutlined,
  KeyOutlined,
  LayoutOutlined,
  LoginOutlined,
  MoneyCollectOutlined,
  RiseOutlined,
  SendOutlined,
  ShoppingOutlined,
  SoundOutlined,
  SwapOutlined,
  TagsOutlined,
  TransactionOutlined,
  TranslationOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
};

export const ICON_NAMES = Object.keys(ICON_MAP);

export function renderIcon(name?: string, props: Record<string, any> = {}) {
  if (!name) return null;
  const Icon = ICON_MAP[name] || AppstoreOutlined;
  return <Icon {...props} />;
}
